import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-type-script-compiler',
	templateUrl:'./TypeScriptCompilerPluginCompPage.html',
	styles: [],
	styleUrls:['./TypeScriptCompilerPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class TypeScriptCompilerPluginCompPage
{
	mdContent_1115 = `\`\`\`java
import com.jwebmp.core.angular.compiler.TypeScriptCompiler;
\`\`\``;
}
